import clsx from "clsx";
import { FunctionComponent } from "react";

import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";
import HamburgerIcon from "@voxmedia/duet-ui/components/icon/HamburgerIcon";
import * as styles from "@voxmedia/duet-ui/components/navigation/Navigation/components/MinimalNav/MinimalNav.css";
import SELECTORS from "@voxmedia/duet-ui/config/class-selectors.config";
import { useNavigationContext } from "@voxmedia/duet-ui/context/navigation-context";
import { withGracefulErrorBoundary } from "@voxmedia/duet-ui/errors/GracefulErrorBoundary";

interface Props {
  Logo: FunctionComponent<{ className?: string }>;
  headline?: string;
  isBranded?: boolean;
  className?: string;
}

/**
 * CSK minimal nav: framework MinimalNav layout (hamburger only; comments live in
 * SubscribeNavOverlay between subscribe and the menu button).
 */
const CskMinimalNav: FunctionComponent<Props> = ({
  Logo,
  headline,
  isBranded = false,
  className,
}) => {
  const { openDrawer, drawerId } = useNavigationContext();
  const analytics = useAnalytics();
  const handleMoreBtnClick = () => {
    openDrawer();
    analytics?.emit({
      event: "navigation_click",
      navigation_click: { name: "minimal nav more button" },
    });
  };

  const variant = isBranded ? "branded" : "normal";

  return (
    <nav
      aria-label="Navigation Bar"
      className={clsx(
        SELECTORS.MinimalNav,
        styles.container[variant],
        className,
      )}
    >
      <div className={styles.innerContainer}>
        <a
          href="/"
          aria-label="Click to visit the homepage"
          tabIndex={-1}
          className={styles.logoContainer}
        >
          <Logo className={clsx(styles.logo[variant])} />
        </a>

        {headline ? <div className={styles.headline}>{headline}</div> : null}
        <div className={styles.rightMenu}>
          <button
            onClick={handleMoreBtnClick}
            aria-controls={drawerId}
            aria-label="Open Drawer"
          >
            <HamburgerIcon className={clsx(styles.moreIcon[variant])} />
          </button>
        </div>
      </div>
    </nav>
  );
};

export default withGracefulErrorBoundary(CskMinimalNav, {
  context: "CskMinimalNavErrorBoundary",
});
